<rask-container-block class="rask-preview-viol3-page">
  <ng-container header>Kontrakt</ng-container>
  <div class="row">
    <div class="col-3">
      <div class="col-header">
        Identitet
      </div>

      <rask-input label="Dokumentnummer" value="{{kontraktData.documentNumber}}" [readonly]="true"></rask-input>
      <rask-input label="Förstaledskontrakt" value="{{kontraktData.serviceProviderDocumentNumber}}" [readonly]="true"></rask-input>
    </div>
    <div class="col-3">
      <div class="col-header">
        Datum
      </div>
      <rask-input label="Kontraktsdatum" value="{{kontraktData.contractDate}}" [readonly]="true"></rask-input>
    </div>
    <div class="col-3">
      <div class="col-header">
        Säljare
      </div>
      <rask-input label="Säljare, namn" value="{{kontraktData.supplierParty?.name}}" [readonly]="true"></rask-input>
      <rask-input label="Köparens identitet på säljaren" value="{{kontraktData.supplierParty?.assignedByAgency}}" [readonly]="true"></rask-input>
    </div>
    <div class="col-3">
      <div class="col-header">
        Köpare
      </div>
      <rask-input label="Köpare, namn" value="{{kontraktData.buyerParty?.name}}" [readonly]="true"></rask-input>
      <rask-input label="Köpare" value="{{kontraktData.buyerParty?.assignedByAgency}}" [readonly]="true"></rask-input>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <rask-input label="Namn" value="{{kontraktData.name}}" [readonly]="true"></rask-input>
    </div>
    <div class="col-3">
      <rask-input label="Giltigt from" value="{{kontraktData.validFrom}}" [readonly]="true"></rask-input>
      <rask-input label="Giltigt tom" value="{{kontraktData.validTo}}" [readonly]="true"></rask-input>
    </div>
    <div class="col-3">
      <rask-input label="Svenskt personnummer säljare" value="{{kontraktData.supplierParty?.traderegnumber}}" [readonly]="true"></rask-input>
    </div>
  </div>

  <hr>

    <div class="row">
      <div class="col-12">
        <div class="col-header">
          Villkor
        </div>
        <rask-input label="Anskaffningsform" value="{{kontraktData.buyerRelationContractedObjectCodeValue}}" [readonly]="true"></rask-input>
        <rask-input label="Avtalsform" value="{{kontraktData.additionalItemInfoDeliveryTerm}}" [readonly]="true"></rask-input>
      </div>
      <div class="col-12">
        <rask-input label="Ersättningsgrundande mätning" value="{{kontraktData.compensationMeasuringType}}" [readonly]="true"></rask-input>
        <rask-input label="Valuta" value="{{kontraktData.contractedCurrency}}" [readonly]="true"></rask-input>
        <rask-input label="Omfattas av VML" value="{{kontraktData.vml}}" [readonly]="true"></rask-input>
        <rask-input label="Initiera transportaffär" value="{{kontraktData.ignoreTransportDeal}}" [readonly]="true"></rask-input>
        <rask-input label="Mätbesked" value="{{getMeasuringTicketPreview(kontraktData)}}" [readonly]="true"></rask-input>
        <rask-input label="Avser industri" value="{{kontraktData.avserIndustri}}" [readonly]="true"></rask-input>
        <rask-input label="Site" value="{{kontraktData.site}}" [readonly]="true"></rask-input>
      </div>
    </div>

    <hr>

      <div class="row">
        <div class="col-12">
          <div class="col-header">
            Rader
          </div>
        </div>
      </div>
      <div class="row preview-table-wrapper">
        @if (kontraktData.contractLines?.length > 0) {
          <div class="col-12">
            <rask-table customStyle="structured-readonly" [data]="kontraktData.contractLines" [columns]="tableColumns"></rask-table>
          </div>
        }
      </div>
    </rask-container-block>
    <rask-container-block class="rask-preview-viol3-page">
      <ng-container header>Avtalsobjekt</ng-container>
      <rask-viol3-avtalsobjekt [data]="kontraktData.deliverySources" [requestedAvtalsobjekt]="kontraktData.requestedAvtalsobjektDokunmentnummer"></rask-viol3-avtalsobjekt>
    </rask-container-block>